/*公共方法*/
import router from "../router/index";
import api from './oidcRoot';
import fileUpload from './fileUpload';

const imgUrl = process.env.IMG_URL;    //接口前缀

let util = {
  timeFormat: (value, f) => {
    if (!f) f = 'yyyy-MM-dd'
    if (!value) return ''
    var elem = new Date(value)
    var o = {
      'M+': elem.getMonth() + 1, // 月
      'd+': elem.getDate(), // d日
      'h+': elem.getHours(), // 时
      'm+': elem.getMinutes(), // 分
      's+': elem.getSeconds(), // 秒
      'q+': Math.floor((elem.getMonth() + 3) / 3),
      'S': elem.getMilliseconds()
    }
    if (/(y+)/.test(f)) f = f.replace(RegExp.$1, (elem.getFullYear() + '').substr(4 - RegExp.$1.length))
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(f)) f = f.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
    }
    return f
  },
  portrait:function(value,defaultImg){ // 背景图片 url()
    var img = 'data:image/png;base64,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';
    var portrait = 'background: url(' + img + ') no-repeat 0% 0% / cover';
    var value = value || '';
    var url = (value.indexOf('http') != -1) ? value : (imgUrl + value);
    return (!value || value == '') ? portrait : ('background: url(' + url + ') no-repeat center center / cover');
  },
  gotoEmail:function(mail) {
    var mailUrl = mail.split('@')[1];
    mailUrl = mailUrl.toLowerCase();
    if (mailUrl == '163.com') {
      return 'http://mail.163.com';
    } else if (mailUrl == 'vip.163.com') {
      return 'http://vip.163.com';
    } else if (mailUrl == '126.com') {
      return 'http://mail.126.com';
    } else if (mailUrl == 'qq.com' || mailUrl == 'vip.qq.com' || mailUrl == 'foxmail.com') {
      return 'http://mail.qq.com';
    } else if (mailUrl == 'gmail.com') {
      return 'http://mail.google.com';
    } else if (mailUrl == 'sohu.com') {
      return 'http://mail.sohu.com';
    } else if (mailUrl == 'tom.com') {
      return 'http://mail.tom.com';
    } else if (mailUrl == 'vip.sina.com') {
      return 'http://vip.sina.com';
    } else if (mailUrl == 'sina.com.cn' || mailUrl == 'sina.com') {
      return 'http://mail.sina.com.cn';
    } else if (mailUrl == 'tom.com') {
      return 'http://mail.tom.com';
    } else if (mailUrl == 'yahoo.com.cn' || mailUrl == 'yahoo.cn') {
      return 'http://mail.cn.yahoo.com';
    } else if (mailUrl == 'tom.com') {
      return 'http://mail.tom.com';
    } else if (mailUrl == 'yeah.net') {
      return 'http://www.yeah.net';
    } else if (mailUrl == '21cn.com') {
      return 'http://mail.21cn.com';
    } else if (mailUrl == 'hotmail.com') {
      return 'http://www.hotmail.com';
    } else if (mailUrl == 'sogou.com') {
      return 'http://mail.sogou.com';
    } else if (mailUrl == '188.com') {
      return 'http://www.188.com';
    } else if (mailUrl == '139.com') {
      return 'http://mail.10086.cn';
    } else if (mailUrl == '189.cn') {
      return 'http://webmail15.189.cn/webmail';
    } else if (mailUrl == 'wo.com.cn') {
      return 'http://mail.wo.com.cn/smsmail';
    } else if (mailUrl == '139.com') {
      return 'http://mail.10086.cn';
    } else if (mailUrl == 'chukou1.com') {
      return 'http://mail.chukou1.com/';
    } else {
      return '';
    }
  },
  // 获取地址栏参数
  getQueryString:function(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    if (window.location.href.split("?")[1] != undefined) {
      var r = window.location.href.split("?")[1].match(reg);
      if (r == undefined && window.location.href.split("?").length > 2) {
        r = window.location.href.split("?")[2].match(reg);
      }
      if (r != null) return decodeURIComponent(r[2]);
      return null;
    }
  },
  // 获取地址栏参数 不转码
  getQueryString_:function(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    if (window.location.href.split("?")[1] != undefined) {
      var r = window.location.href.split("?")[1].match(reg);
      if (r == undefined && window.location.href.split("?").length > 2) {
        r = window.location.href.split("?")[2].match(reg);
      }
      if (r != null) return r[2];
      return null;
    }
  },
  //根据dom坐标调整引导图位置
  guideOP(objG, obj,isWrap) {
    if(isWrap) {
      objG.style.top = obj.top  + 'px'
      objG.style.left = obj.left  + 'px'
      objG.style.width = obj.width + 'px'
      objG.style.height = obj.height + 'px'
    } else {
      objG.style.top = obj.top - 55 + 'px'
      objG.style.left = obj.left - 210 + 'px'
      objG.style.width = obj.width + 'px'
      objG.style.height = obj.height + 'px'
    }

  },
  //获取dom元素位置和尺寸大小
  getObjXy(obj) {
    if (!obj) return
    let xy = obj.getBoundingClientRect();
    let top = xy.top - document.documentElement.clientTop + document.documentElement.scrollTop,//document.documentElement.clientTop 在IE67中始终为2，其他高级点的浏览器为0
      bottom = xy.bottom,
      left = xy.left - document.documentElement.clientLeft + document.documentElement.scrollLeft,//document.documentElement.clientLeft 在IE67中始终为2，其他高级点的浏览器为0
      right = xy.right,
      width = xy.width || right - left, //IE67不存在width 使用right - left获得
      height = xy.height || bottom - top;

    return {
      top: top,
      right: right,
      bottom: bottom,
      left: left,
      width: width,
      height: height
    }
  },
  //点击顶部导航
  clickTitNav(key,staus,tabName,id){
    if(staus){
      localStorage["vatStaus"] = staus;
    }else{
      staus = '';
      localStorage.removeItem('vatStaus');
    }
    if(key == "ProductAndServceMenuItem") {         //产品与服务
      router.push({path: `/home`})
    }
    else if(key == "ProductLibraryHomeMenuItem") {         //工作看板
      router.push({path: `/ProductLibraryHomeMenuItem`})
    }
    else if(key == "ExpenseCenterMenuItem"){        //费用中心
      router.push({path:`/vsCost/${key}`})
    }
    else if(key == "UserCenterMenuItem"){           //用户中心
      router.push({path:`/vsUs/${key}`})
    }
    else if(key == "PlatformStoreManagementMenuItem"){//绑定店铺
      router.push({path:`/vsBind/${key}`})
    }
    else if(key == "VatServiceMenuItem"){                  //VAT
      if(tabName){
        // tabName = `{ path, query}`
        if (typeof tabName === 'string') {
          localStorage["vatRouterData"] = tabName
        } else {
          localStorage["vatRouterData"] = JSON.stringify(tabName)
        }
      }else{
        localStorage.removeItem('vatRouterData');
      }
      if (tabName && typeof tabName === 'string') {
        router.push({path:`/vat`,query:{id:staus, tabName: tabName ,timeStamp:Number(new Date())}})
        return
      }
      router.push({path:`/vat`,query:{id:staus, tabName: (tabName ? true : false) ,timeStamp:Number(new Date())}})
    }
    else if(key == "TrackingYeeServiceMenuItem"){         //ty
      router.push({path:`/tyPortal`,query:{id:staus,tabName:tabName,timeStamp:Number(new Date())}})
    }
    else if(key == "purchaseService"){        //ty购买服务
      router.push({path:`/tyPurchaseService`})
    }
    else if(key == "ProductLibraryProductMenuItem"){        //产品库——产品+商品
      router.push({path:`/productService`,query:{id:staus,tabName:tabName,timeStamp:Number(new Date())}})
    }
    else if(key == "FulfillmentServiceMenuItem"){        //ERP销售工具
      router.push({path:`/fulfillment`,query:{id:staus,tabName:tabName,timeStamp:Number(new Date())}})
    }
    else if(key == "logProviderAuth"){        //物流商授权
      router.push({path:`/fulfillment`,query:{id:staus}})
    }
    else if(key == "platformGreenChannel"){   //平台绿色通道
      router.push({path:`/platformgreenchannel`})
    }
    else if (key == "ProductLibraryMerchandiseMenuItem") {   // 同步平台商品
      router.push({ path: `/productService`, query: {id:staus} })
    }
    // ----------------------采购管理----------------------------
    else if (key == "PurchasePlanMenuItem") {   // 采购计划
      router.push({ path: `/purchase`, query: {id:staus,tabName:tabName,timeStamp:Number(new Date())} })
    }
  },

  // loading开始
  beginLoading(){
    document.getElementById('loadingFirstXQ').style.display = 'none'
    if(document.getElementById('loadingXQ')){
      document.getElementById('loadingXQ').style.display = 'block';
    }
  },
  // loading结束
  finishLoading(){
    document.getElementById('loadingFirstXQ').style.display = 'none'
    if(document.getElementById('loadingXQ')){
      document.getElementById('loadingXQ').style.display = 'none';
    }
  },
  /*
 * todo 图片id 转bolb展示
 * */
  wq_packageImgShow(Id, callBack) {
    let imgShowURl = `/File/${Id}?type=Stream`;
    fileUpload.getImg(imgShowURl).then(resp => {
      this.finishLoading();
      callBack(window.URL.createObjectURL(resp.data));
    }).catch(e => {
      this.finishLoading();
      callBack('./static/image/lost.png')
    })
  },
  //文件流下载
  Export(data, fileName) {
    const blob = new Blob([data]);
    if ('download' in document.createElement('a')) { // 非IE下载
      const elink = document.createElement('a');
      elink.setAttribute("download", fileName);
      elink.style.display = 'none';
      elink.href = URL.createObjectURL(blob);
      document.body.appendChild(elink);
      elink.click();
      URL.revokeObjectURL(elink.href);// 释放URL 对象
      document.body.removeChild(elink);
    } else { // IE10+下载
      navigator.msSaveBlob(blob, fileName);
    }
  },
  //存入缓存
  setLocalstorage: function (name,item) {
    localStorage.setItem(name,JSON.stringify({item:item,time:new Date().getTime()}))
  },
  //调用缓存
  getLocalstorage: function (name, time) {
    time = time || 180000; //默认30分钟不过期
    var s = localStorage.getItem(name);
    var result = false;
    if (s) {
      s = JSON.parse(s);
      //不过期
      if (time == 0 || new Date().getTime() < parseInt(s.time) + parseInt(time)) {
        result = s.item;
      }else{
        localStorage.removeItem(name);
      }
    }
    return result;
  },

  // 获取权限
  getpermissions(permissCode,permissCallback){
    var profile = localStorage['profile']?JSON.parse(localStorage['profile']):"";
    api.getApi('/Accounts/permissions', 'GET', '', (data) => {
      console.log(data)
      // let res = JSON.parse(data)
      localStorage["profile"] = data;
      profile = JSON.parse(data);
      permissCallback(profile)
    })
  },
  // 打开PDF
  openPDF(fileHost,name,str){
    window.open(fileHost,name,str)
  },
  toError(id){
    router.push({path:'/error',query:{errorId:id}})
  },
  //绑定店铺，商品列表，产品列表
  toAnyWhere(path,data){
    router.push({path:path,query:data})
  },

  logAuth(data){
    window.location.replace(data)
  }
}


window.clickTitNav = util.clickTitNav;
window.beginLoading = util.beginLoading;
window.finishLoading = util.finishLoading;
window.Export = util.Export;
window.openPDF = util.openPDF;
window.isFather = 'portal';
window.toError = util.toError;
window.logAuth = util.logAuth;
window.toAnyWhere = util.toAnyWhere
export default util;



// WEBPACK FOOTER //
// ./src/public/common.js